import { Box } from "@mui/material";
import React from "react";
import styles from "../../styles/components/partnerListItem.module.scss";
// import Image from "next/image";
import assest from "../../json/assest";
import { emptyHandleTwo } from "../../lib/functions/utils.lib";
// import Link from "next/link";

// interface PartnerListItemProps {
//     cardVideoCount: number;
//     cardVideoApprovedCount: number;
//     cardVideoRejectedCount: number;
//     cardVideoDuplicateCount: number;
// }

const ContentBuyerListItem = (props) => {
  return (
    <Box className={styles.partnerLIstItem}>
      <Box className={styles.partnerItem}>
        <Box className={styles.partnerItemImg}>
          <img
            src={assest.partnerSubmissionIcon}
            width={16}
            height={16}
            alt=""
          />
        </Box>

        <Box className={styles.partnerItemTxt}>
          <h5>All Videos</h5>
          <p>
            {emptyHandleTwo(
              props?.contentBuyerSubmissions?.data?.data?.all_submissions?.total
            )}
          </p>
        </Box>
      </Box>
      <Box className={styles.partnerItem}>
        <Box className={styles.partnerItemImg}>
          <img
            src={assest.partnerApproveIcon}
            width={16}
            height={16}
            alt="img"
          />
        </Box>

        <Box className={styles.partnerItemTxt}>
          <h5>All-Platform</h5>
          <p>
            {emptyHandleTwo(
              props?.contentBuyerSubmissions?.data?.data?.all_submissions
                ?.approved
            )}
          </p>
        </Box>
      </Box>
      <Box className={styles.partnerItem}>
        <Box className={styles.partnerItemImg}>
          <img src={assest.websiteIcon} width={16} height={16} alt="img" />
        </Box>

        <Box className={styles.partnerItemTxt}>
          <h5>Website Only</h5>
          <p>
            {emptyHandleTwo(
              props?.contentBuyerSubmissions?.data?.data?.all_submissions
                ?.website_only
            )}
          </p>
        </Box>
      </Box>
      <Box className={styles.partnerItem}>
        <Box className={styles.partnerItemImg}>
          <img src={assest.purchaseIcon} width={16} height={16} alt="img" />
        </Box>

        <Box className={styles.partnerItemTxt}>
          <h5>Total Purchases</h5>
          <p>
            {props?.contentBuyerSubmissions?.data?.data?.accounting
              ?.total_purchase
              ? `$${emptyHandleTwo(
                  props?.contentBuyerSubmissions?.data?.data?.accounting
                    ?.total_purchase
                )}`
              : "-"}
          </p>
        </Box>
      </Box>
    </Box>
  );
};

export default ContentBuyerListItem;
